<template lang="pug">
  div(v-if="value")
    validation-observer(ref="obs" v-slot="{ invalid, validated, passes, validate, pristine }")
      v-dialog(
        v-model="dialog"
        :title="title"
        max-width="800"
      )
        v-card
          v-card-title {{ editable ? 'Редактирование поля': 'Добавить новое поле'}}
          v-card-text
            template(
              v-for="field in fields"
            )
              validation-provider(
                :key="field.text"
                :rules="field.rules"
                :name="field.text"
                :vid="field.value"
                v-slot="{ errors, valid }"
              )
                component(
                  :is="field.component"
                  v-model="value[field.value]"
                  v-bind="field.component_attrs"
                )
          v-card-actions
            v-btn(v-if="editable" color="error" @click="updateInputs(true)") Удалить
            v-spacer
            v-btn(
              text
              rounded
              @click="dialog = false"
            ) Отмена
            v-btn(
              color="success"
              depressed
              rounded
              :disabled="invalid"
              @click="updateInputs(false)"
            ) Сохранить
</template>

<script>
import OptionsInput from '@/components/InputFields/OptionsInput.vue';
import { INPUT_TEXT_TYPES, INPUT_TYPES } from '@/modules/CourseManagement/constants';

export default {
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    inputTypes: { type: Object, default: () => INPUT_TEXT_TYPES },
    additionalFields: {
      type: Object,
      default: () => ({
        [INPUT_TYPES.list]: [
          {
            value: 'value_options',
            text: 'Опции',
            rules: 'required',
            component: OptionsInput,
          },
        ],
      }),
    },
  },
  data() {
    return {
      INPUT_TEXT_TYPES,
      initial: {},
      dialog: false,
      isLoadedDelete: false,
    };
  },
  computed: {
    title() {
      const prefix = this.editable ? 'Редактировать' : 'Создать';
      return `${prefix} поле`;
    },
    fields() {
      return [
        {
          value: 'type',
          text: 'Тип',
          rules: 'required',
          component: 'v-select',
          component_attrs: {
            label: 'Тип',
            outlined: true,
            rounded: true,
            items: Object.entries(this.inputTypes).map(([key, value]) => ({
              text: value,
              value: Number(key),
            })),
          },
        },
        {
          value: 'name',
          text: 'Название',
          rules: 'required',
          component: 'v-text-field',
          component_attrs: {
            label: 'Название',
            outlined: true,
            rounded: true,
          },
        },
        {
          value: 'description',
          text: 'Описание',
          rules: 'required',
          component: 'v-textarea',
          component_attrs: {
            label: 'Описание',
            outlined: true,
            rounded: true,
          },
        },
        ...this.inputFields ? this.inputFields : [],
      ];
    },
    inputFields() {
      const { value } = this;
      return this.additionalFields[value.type];
    },
  },
  watch: {
    value: {
      handler(value) {
        if (value) this.dialog = true;
      },
      immediate: true,
    },
    dialog(value) {
      if (!value) {
        this.reset();
        this.$emit('close');
      }
    },
  },
  methods: {
    reset() {
      const { formFields } = this.$refs;
      if (formFields) formFields.reset();
    },
    updateInputs(isDelete) {
      this.$emit('update', this.editable, isDelete);
      this.dialog = false;
    },
  },
};
</script>
